import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';

import {SubmitResponseModel} from '../entities/SubmitResponseModel';


@Injectable({
  providedIn: 'root'
})
export class RestService {
  static readonly OSS_CONTEXT_ROOT_URL = '/oss';

  readonly REST_CONTROLLER_URL = RestService.OSS_CONTEXT_ROOT_URL + '/import-by-int/int/registo/';

  readonly SUBMIT_NEW_ENDPOINT = 'submeter-novo-registo';
  readonly SUBMIT_EDIT_ENDPOINT = 'submeter-editar-registo';

  static SUBMIT_HTTP_OPTIONS = {
    headers: new HttpHeaders({
      'Access-Control-Allow-Headers': 'Content-Type',
      'Access-Control-Allow-Methods': 'POST',
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/json'
    }),
  };

  constructor(private http: HttpClient) {
  }

  public submitNew(formValue: object): Observable<SubmitResponseModel> {
    return this.http.post<SubmitResponseModel>(this.getFullUrl(this.SUBMIT_NEW_ENDPOINT), JSON.stringify(formValue), RestService.SUBMIT_HTTP_OPTIONS);
  }

  public submitEdit(formValue: object): Observable<SubmitResponseModel> {
    return this.http.post<SubmitResponseModel>(this.getFullUrl(this.SUBMIT_EDIT_ENDPOINT), JSON.stringify(formValue), RestService.SUBMIT_HTTP_OPTIONS);
  }

  /**
   * Returns the full url of the request.
   */
  private getFullUrl(url: string): string {
    return this.REST_CONTROLLER_URL + url;
  }
}
